<template>
  <div class="receipt-view panel position-relative">

    <div class="header">{{ $t('#TR-view-receipt') }}</div>

    <div class="small-icon-group mt-2 mb-3">
      <button class="btn btn-success"
              @click="print">
        <span class="mdi mdi-printer"></span>
        <span class="d-none d-md-inline"> {{ $t('#TR-print') }}</span>
      </button>
      <button class="btn btn-warning"
              @click="printPdf">
        <span class="mdi mdi-file-pdf"></span>
        <span class="d-none d-md-inline"> {{ $t('#TR-pdf') }}</span>
      </button>
      <button class="btn btn-danger"
              @click="close">
        <span class="mdi mdi-close"></span>
        <span class="d-none d-md-inline"> {{ $t('#TR-close') }}</span>
      </button>
    </div>

    <div class="panel-body position-relative">
      <div class="row mb-3">
        <div v-if="receipt['receiptNum']"
             class="col-6">
          <span class="text-info">{{ $t('#TR-number') }}: </span> <b> {{ receipt['receiptNum'] }}</b>
        </div>
        <div v-if="receipt['rkReceiptNum']"
             class="col-6">
          <span class="text-info">RK-{{ $t('#TR-number') }}: </span> <b> {{ receipt['rkReceiptNum'] }}</b>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div v-for="item in receiptImgList['imgList']"
               :key="item.id"
               class="receipt-img">
            <img :src="'data:image/png;base64,' + item"
                 class="shadow"
                 alt="">
          </div>
        </div>
      </div>
    </div>
    <main-loader></main-loader>
  </div>
</template>

<script>
  import { Rcpt } from '@/modules/receipt';
  import { eventBus } from '@/main';
  import MSG from '@/services/notify';
  import MainLoader from '@/components/Loader';

  export default {

    components: {
      MainLoader
    },

    props: {
      receipt: {
        default: () => {
          return null;
        },
        type: Object
      }
    },

    data() {
      return {
        receiptImgList: {
          imgList: [],
          type: null
        }
      };
    },

    created() {
      this.get();
    },

    methods: {
      get: async function () {
        this.$store.commit('toggleLoader', true);

        const result = await Rcpt.receiptFDPreview(this.receipt.id);
        if (!result.error) {
          this.receiptImgList = result;
        } else {
          MSG.error(result.error, this);
        }
        this.$store.commit('toggleLoader', false);
      },

      close: function () {
        this.$emit('close');
      },

      print: function () {
        eventBus.$emit('printData', {
          data: this.receipt.id,
          type: 'fdReceipt'
        });
      },

      printPdf: function () {
        Rcpt.getFDReceiptPDF(this.receipt.id);
      }
    }

  };
</script>

<style lang="stylus">
.receipt-img {
  img {
    display: block
    margin: 0 auto
  }
}


@media (max-width: 500px) {
  .receipt-img {
    img {
      display: block
      margin: 0 auto
      width: 100%
    }
  }
}


</style>
